import { Page } from '@/core/architecture'

import { DeliveryManagementTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * DeliveryManagement Page
 * Implemented as a practical sample.
 */
export const DeliveryManagement: Page = () => {
  const { state, actions } = useViewModel()

  return <DeliveryManagementTemplate state={state} {...actions} />
}
